import React from 'react';
import { Divider, Row, Col } from 'antd';

import { getFullName } from 'utils/personUtils';
import { AssignmentBillingContactViewModel } from 'api/backofficeApiClient';

type Props = {
  contact: AssignmentBillingContactViewModel
  index: number;
};

export default function BillingContactInfoSection(props: Props) {
  const { contact, index } = props;
  const contactName = getFullName(contact?.firstName, contact?.lastName);

  return (
    <div className="divider-box sub-content">
      <div className="content-wrapper">
        <Row>
          {!!contactName && (
            <Col xs={24} md={12} data-id={`billingContactName-${index}`}>
              <div className="title">Billing contact: </div>
              <div>{contactName}</div>
            </Col>
          )}

          {contact?.email && (
            <Col xs={24} md={12} data-id={`billingContactEmail-${index}`}>
              <div className="title">Email: </div>
              <div>{contact.email}</div>
            </Col>
          )}

          {contact?.phoneNumber && (
            <Col
              xs={24}
              md={12}
              data-id={`billingContactPhoneNumber--${index}`}
            >
              <div className="title">Phone number: </div>
              <div>{contact?.phoneNumber}</div>
            </Col>
          )}
        </Row>
      </div>
      <Divider className="card-divider no-margin" />
    </div>
  );
}
